export * from "./mensmagazine";

// 週プレ関連定数定義
/** 連携名 */
export const WEEKLY_PLAYBOY_LINKAGE_NAME = "WeeklyPlayboy";
/** 画面パス */
export const WEEKLY_PLAYBOY_PATH = "weekly_playboy";
/** デフォルトコールバックURL */
export const WEEKLY_PLAYBOY_DEFAULT_CALLBACK_URL = process.env.VUE_APP_WEEKLY_PLAYBOY_DEFAULT_CALLBACK_URL;
/** 許容コールバックURL */
export const WEEKLY_PLAYBOY_ACCEPT_CALLBACK_URLS = process.env.VUE_APP_WEEKLY_PLAYBOY_ACCEPT_CALLBACK_URLS.split(",").map((url: string) => `^${url}(\\?.*)?$`);
/** サービス規約URL */
export const WEEKLY_PLAYBOY_SERVICE_TERM_URL = process.env.VUE_APP_WEEKLY_PLAYBOY_SERVICE_TERM_URL;
/** メールアドレスドメイン */
export const WEEKLY_PLAYBOY_EMAIL_DOMAINS = [
    "grajapa.shueisha.co.jp",
    "wpb.shueisha.co.jp",
    "wpb.sid.shueisha.co.jp"
];
/** 連携サブID */
export const WEEKLY_PLAYBOY_LINKAGE_SUB_ID = 0;
